"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var HeaderWrapper = styled_components_1["default"](box_1["default"])({
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 64px',
});
var HeaderText = styled_components_1["default"](text_1["default"])(function (props) { return ({
    color: props.theme.colors.black.haptik,
    textAlign: 'center',
}); });
var StepsHeaderText = styled_components_1["default"](text_1["default"])(function (props) { return ({
    color: props.theme.colors.grey.deep,
}); });
var StepsContainerStyles = function (props) { return ({
    color: props.theme.colors.black.haptik,
    borderRadius: props.theme.radii.sm,
    padding: '8px 20px',
    margin: '16px 0px 0px 0px',
}); };
var DownloadWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    background: props.theme.colors.blue.pastel + "33",
    border: "1px solid " + props.theme.colors.blue.pastel,
}); }, StepsContainerStyles);
var UploadWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    background: props.theme.colors.green.pastel + "33",
    border: "1px solid " + props.theme.colors.green.pastel,
}); }, StepsContainerStyles);
var FooterLinkWrapper = styled_components_1["default"](box_1["default"])({
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 0px',
});
/**
 * A modal which can be used for download and upload actions.
 */
var UploadModal = function (_a) {
    var isActive = _a.isActive, onClose = _a.onClose, modalStyles = _a.modalStyles, downloadContent = _a.downloadContent, uploadContent = _a.uploadContent, headerText = _a.headerText, footerText = _a.footerText, bodyContent = _a.bodyContent;
    return (react_1["default"].createElement(modal_1["default"], { themed: true, active: isActive, onClose: onClose, style: modalStyles },
        react_1["default"].createElement(box_1["default"], { width: "565px", padding: "zero", flexDirection: "column" },
            headerText && (react_1["default"].createElement(HeaderWrapper, null,
                react_1["default"].createElement(HeaderText, { variant: "display-2.semi-bold" }, headerText))),
            react_1["default"].createElement(box_1["default"], { padding: "0px 0px 0px 24px", flexDirection: "column" },
                react_1["default"].createElement(StepsHeaderText, { variant: "body.lg" }, "Steps to follow:"),
                downloadContent && (react_1["default"].createElement(DownloadWrapper, null, downloadContent)),
                uploadContent && react_1["default"].createElement(UploadWrapper, null, uploadContent)),
            bodyContent && bodyContent,
            footerText && (react_1["default"].createElement(FooterLinkWrapper, null,
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, footerText))))));
};
exports["default"] = UploadModal;
